import type { CohortAnnouncement } from '@efdigital/ll-xceed-v2/data/builders/xceed/messages';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import type CohortAnnouncementsService from '@efdigital/ll-xceed-v2/services/cohort-announcements';
import { cohortShowsAnnouncements } from '@efdigital/ll-xceed-v2/utils/coaching/announcements';

export async function syncCoacheeCohortAnnouncements(
  coachee: CoacheeService,
  programId: string,
  cohortId: string,
  cohortCss: string | null | undefined,
  cohortAnnouncements: CohortAnnouncementsService
): Promise<CohortAnnouncement[]> {
  if (!cohortShowsAnnouncements(cohortCss)) {
    cohortAnnouncements.sync([], programId, cohortId);
    return [];
  }

  const announcements = await coachee
    .getCohortAnnouncements(programId, cohortId)
    .catch(() => []);

  cohortAnnouncements.sync(announcements, programId, cohortId);
  return announcements;
}
